module.exports = __webpack_public_path__ + "img/arrow-left.ff5c335e.svg";